import ArrowCircleLeft from '@assets/icons/arrow-circle-left.svg'
import { Icon } from './Icon'

export const ArrowCircleLeftIcon = Icon(ArrowCircleLeft)
